<template>
  <div :class="['condition-list', from, realSize]">
    <div
      v-if="_.isEmpty(conditions) && from !== 'chart_control'"
      class="add-condition-btn"
      @click="addCondition()"
    >
      添加筛选条件
    </div>
    <div v-else>
      <div v-for="(andConditions, andIdx) in conditions" :key="andIdx" class="condition-container">
        <div v-if="andIdx != 0" class="tag-or">
          <span>或</span>
        </div>

        <div class="condition-item-wrapper" v-for="(condition, idx) in andConditions" :key="idx">
          <condition-item
            :value="condition"
            :disabled="disabled"
            :key-list="keyList"
            :control-map="controlMap"
            :rely-sheet-var-list="relySheetVarList"
            :simple-workflow-var-list="simpleWorkflowVarList"
            :workflow-var-control-map="workflowVarControlMap"
            :simple-query-condition-list="simpleQueryConditionList"
            :var-label-map="varLabelMap"
            :from="from"
            :size="realSize"
            :app-roles="appRoles"
            :company-roles="companyRoles"
            :sheet-id="sheetId"
          ></condition-item>

          <span v-if="!disabled" class="icon-delete" @click="delCondition(andIdx, idx)">
            <svg-icon icon-class="svgo_close-round"></svg-icon>
          </span>

          <div
            class="button-wrapper"
            v-if="idx === andConditions.length - 1 && !disabled && canEdit"
          >
            <base-button @click="addCondition(andIdx)">
              + 且
            </base-button>
            <base-button v-if="andIdx === conditions.length - 1" @click="addCondition()">
              + 或
            </base-button>
          </div>

          <div v-else-if="!disabled" class="tag-and">且</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import ConditionItem from "@/components/UIComponents/ConditionList/ConditionItem"
import { transFieldControl, verifyCondition } from "@/utils/sheet"
import { getAllDefaultControls } from "@/api/sheet/sheet"
import { bfs } from "@/utils/algorithm"
import { transWorkflowVarGroup2TreeVarGroup } from "@/utils/workFlow"
import { isObject, getDateExpression } from "@/utils/common"

export default {
  name: "condition-list",
  components: { ConditionItem, BaseButton },
  props: {
    conditions: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    canEdit: {
      type: Boolean,
      default: true
    },
    // 查询目标表(工作流中使用无需传入)
    searchSheet: {
      type: Object
      // default: () => ({
      //   sheetId: null,
      //   controls: []
      // })
    },
    relySheet: Object, // 变量来源工作表, from==sheet_backend必填
    from: {
      type: String,
      default: "sheet_frontend" // sheet_frontend,sheet_backend,workflow_gateway,workflow_search
    },
    workflowVarList: Array, // 变量来源工作流, null不显示选择工作流变量按钮
    queryConditionList: Array, // 看板查询条件，null不显示选择查询条件按钮
    size: {
      type: String,
      default: null // small normal
    },
    appRoles: Array,
    companyRoles: Array
  },
  computed: {
    _searchSheet() {
      return this._.cloneDeep(this.searchSheet)
    },
    sheetId() {
      return this._searchSheet?.sheetId || null
    },
    _relySheet() {
      return this._.cloneDeep(this.relySheet)
    },
    localControls() {
      if (!this._searchSheet) return []
      let isSheet = Boolean(this._searchSheet.sheetId)
      return []
        .concat(
          isSheet
            ? {
                name: "ID",
                _cid: "id",
                _type: "ref",
                refSheetId: this._searchSheet.sheetId,
                oneFlag: true
              }
            : []
        )
        .concat(this._searchSheet.controls || [])
        .concat(
          isSheet
            ? [
                { name: "创建人", _cid: "cid", _type: "staff", _dataType: "list" },
                { name: "负责人", _cid: "oid", _type: "staff", _dataType: "list" },
                { name: "参与人", _cid: "pts", _type: "staff", _dataType: "list" },
                { name: "最后修改人", _cid: "upid", _type: "staff", _dataType: "list" },
                {
                  name: "创建时间",
                  _cid: "cat",
                  _type: "time",
                  timeType: "年月日时分秒",
                  _dataType: "time"
                },
                {
                  name: "最后修改时间",
                  _cid: "uat",
                  _type: "time",
                  timeType: "年月日时分秒",
                  _dataType: "time"
                }
              ]
            : []
        )
        .map(control => transFieldControl(control))
    },
    searchSheetControls() {
      let isSheet = Boolean(this._searchSheet.sheetId)
      return (this._searchSheet?.controls || [])
        .concat(
          isSheet
            ? [
                { name: "创建人", _cid: "cid", _type: "staff", _dataType: "list" },
                { name: "负责人", _cid: "oid", _type: "staff", _dataType: "list" },
                { name: "参与人", _cid: "pts", _type: "staff", _dataType: "list" },
                { name: "最后修改人", _cid: "upid", _type: "staff", _dataType: "list" },
                {
                  name: "创建时间",
                  _cid: "cat",
                  _type: "time",
                  timeType: "年月日时分秒",
                  _dataType: "time"
                },
                {
                  name: "最后修改时间",
                  _cid: "uat",
                  _type: "time",
                  timeType: "年月日时分秒",
                  _dataType: "time"
                }
              ]
            : []
        )
        .filter(control => this.controlTypeMap[control._type])
        .map(control => transFieldControl(control))
    },
    relySheetControls() {
      return (this._relySheet?.controls || [])
        .filter(control => this.controlTypeMap[control._type])
        .map(control => transFieldControl(control))
    },
    controlMap() {
      return this._.keyBy(this.localControls.concat(this.relySheetControls), "_cid")
    },
    controlTypeMap() {
      return this._.keyBy(this.defaultControls, "_type")
    },
    keyList() {
      return this.localControls
        .filter(
          control =>
            this.controlTypeMap[control._type] &&
            !["remark", "code", "chart"].includes(control._type)
        )
        .map(control => ({
          value: control._cid,
          label: `[${this.controlTypeMap[control._type].name}] ${control.name}`
        }))
    },
    relySheetVarList() {
      let result = []
      if (!this._.isEmpty(this._relySheet) || !this._.isEmpty(this._searchSheet)) {
        if (!this._.isEmpty(this._searchSheet) && this.from !== "sheet_backend") {
          result.push({
            label: "自己",
            options: this.searchSheetControls
              .filter(control => control._type !== "remark")
              .map(control => {
                return {
                  label: `[${this.controlTypeMap[control._type].name}] ${control.name}`,
                  value: control._cid,
                  cid: control._cid,
                  control
                }
              })
          })
        }
        if (!this._.isEmpty(this._relySheet)) {
          result.push({
            label: "特殊变量",
            options: [
              {
                label: "[对象] 自己",
                value: "self",
                control: {
                  _type: "ref",
                  _dataType: "ref",
                  refSheetId: this._relySheet.sheetId
                }
              }
            ]
          })
          result.push({
            label: "普通变量",
            options: this.relySheetControls
              .filter(control => control._type !== "remark")
              .map(control => {
                return {
                  label: `[${this.controlTypeMap[control._type].name}] ${control.name}`,
                  value: control._cid,
                  cid: control._cid,
                  control
                }
              })
          })
        }
      }
      return result
    },
    workflowVarControlMap() {
      let map = {}
      bfs({
        arr: this.simpleWorkflowVarList,
        childFuc: varGroup => varGroup.children,
        cbk: varGroup =>
          (varGroup.options || []).forEach(option => (map[option.value] = option.control))
      })
      return map
    },
    varLabelMap() {
      let map = {}
      let group = ["sheet_backend", "chart_control", "sheet_frontend"].includes(this.from)
        ? this.relySheetVarList
        : this.from === "board_query"
        ? this.simpleQueryConditionList
        : this.simpleWorkflowVarList
      bfs({
        arr: group,
        childFuc: varGroup => varGroup.children,
        cbk: varGroup =>
          (varGroup.options || []).forEach(option => (map[option.value] = option.label))
      })
      return map
    },
    simpleWorkflowVarList() {
      return transWorkflowVarGroup2TreeVarGroup(this.workflowVarList, this.controlTypeMap)
    },
    simpleQueryConditionList() {
      let result = []
      result.push({
        label: "查询条件",
        options: this.queryConditionList?.map(condition => ({
          label: `[${this.controlTypeMap[condition.type]?.name}] ${condition.name}`,
          value: condition.id
        }))
      })
      if (!this._.isEmpty(this._searchSheet)) {
        result.push({
          label: "自己",
          options: this.searchSheetControls
            .filter(control => control._type !== "remark")
            .map(control => {
              return {
                label: `[${this.controlTypeMap[control._type].name}] ${control.name}`,
                value: control._cid,
                cid: control._cid,
                control
              }
            })
        })
      }
      return result
    },
    realSize() {
      return this.size || this.from.startsWith("workflow") ? "normal" : "small"
    }
  },
  data() {
    return {
      defaultControls: []
    }
  },
  created() {
    getAllDefaultControls().then(data => {
      this.defaultControls = data || []
    })
  },
  methods: {
    addCondition(andIdx) {
      let { result, msg } = verifyCondition("add", this.conditions)
      if (!result) {
        this.$message.error(msg)
        return
      }
      let defaultFilter = {
        key: null,
        compareMethod: null,
        type: null,
        varItems: []
      }
      if (andIdx !== undefined) {
        // 添加且条件
        this.conditions[andIdx].push(defaultFilter)
      } else {
        // 添加或条件
        this.conditions.push([defaultFilter])
      }
      this.$emit("add-condition")
    },
    // 删除条件，若这个条件数组只剩这个条件时，删除整个条件数组，否则删除这个元素
    delCondition(conditionBlockIndex, conditionIndex) {
      let conditionBlock = this.conditions[conditionBlockIndex]
      if (conditionBlock.length > 1) conditionBlock.splice(conditionIndex, 1)
      else this.conditions.splice(conditionBlockIndex, 1)
    },
    getConditionDescription() {
      let _ = this._
      let varMap = {}
      bfs({
        arr: this.from == "sheet_backend" ? this.relySheetVarList : this.simpleWorkflowVarList,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(
            option =>
              (varMap[option.value] = _.trim(option.label.slice(option.label.lastIndexOf("]") + 1)))
          )
        }
      })
      let keyMap = ["workflow_gateway", "validate_rule"].includes(this.from)
        ? varMap
        : _.mapValues(_.keyBy(this.keyList, "value"), ({ label }) =>
            _.trim(label.slice(label.lastIndexOf("]") + 1))
          )
      return this.conditions.map(list => {
        return list.map(({ key, compareMethod, type, varItems }) => {
          key = keyMap[key]
          compareMethod = ["真", "假"].includes(compareMethod)
            ? "为" + compareMethod
            : compareMethod
          let value = (varItems || [])
            .map(varItem => {
              if (type !== "time")
                return varItem.var ? varMap[varItem.value] : varItem.label || varItem.value
              else {
                if (isObject(varItem.value)) {
                  let data = JSON.parse(varItem.value)
                  if (!["在期间", "前...天内", "后...天内"].includes(compareMethod)) {
                    return (
                      "系统当前时间" +
                      getDateExpression("年", data.value.years) +
                      getDateExpression("月", data.value.months) +
                      getDateExpression("日", data.value.days) +
                      getDateExpression("时", data.value.hours) +
                      getDateExpression("分", data.value.minutes) +
                      getDateExpression("秒", data.value.seconds)
                    )
                  }
                } else {
                  return varItem.var ? varMap[varItem.value] : varItem.label || varItem.value
                }
              }
            })
            .filter(t => t)
            .join(",")
          return { key, compareMethod, value }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.condition-list {
  line-height: normal;
  &.small {
    ::v-deep {
      .el-input .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
      .compare-value {
        .btn-add {
          height: 32px;
          width: 32px;
        }
        .icon-tip {
          padding-top: 8px;
        }
      }
      .tree-select {
        .tree-select-tags {
          min-height: 32px;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
  }
  &.normal {
    ::v-deep {
      .el-input .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
      .compare-value {
        .select-ref {
          height: 40px;
        }
        .icon-tip {
          padding-top: 12px;
        }
        .user-scope-selector-container {
          min-height: 40px;
          box-sizing: border-box;
          .value-wrapper {
            min-height: 38px;
          }
        }
        .time-wrapper {
          height: 40px;
        }
      }
    }
  }
  .add-condition-btn {
    margin-top: 22px;
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    background: #f5f5f5;
    cursor: pointer;
    color: #1e88e5;
    &:hover {
      color: #1565c0;
    }
  }
  .condition-container {
    .condition-item-wrapper {
      position: relative;
      padding-top: 22px;
      &:hover {
        .icon-delete {
          display: unset;
        }
      }
      .icon-delete {
        display: none;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        font-size: 18px;
        color: #bdbdbd;
        &:hover {
          color: #1e88e5;
        }
      }
      .button-wrapper {
        margin-top: 4px;
      }
    }
    .tag-or {
      margin-top: 10px;
      position: relative;
      text-align: center;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        border-bottom: 1px solid #bdbdbd;
      }
      span {
        display: inline-block;
        padding: 0 10px;
        background: #fff;
        position: relative;
      }
    }
    .tag-and {
      position: relative;
      top: 20px;
    }
  }
  ::v-deep {
    .el-input__validateIcon {
      display: none;
    }
  }
}
</style>
